// extracted by mini-css-extract-plugin
module.exports = {"card":"pages-module_card_LDWBJ","header":"pages-module_header_3XHnR","text":"pages-module_text_1-uAq","redirectLink":"pages-module_redirectLink_z0xYZ"};